export default __webpack_public_path__ + "static/media/project_hero_east_douglas.3ada6a4e.jpg";